import { useEffect, useRef, useState } from 'react';
import { TeamMembership, TeamRole } from '../../pm/types';
import { TEAM_ROLE_LABELS, TEAM_ROLE_ORDER } from '../../pm/constants';
import { removeTeamMember, updateMemberRole } from '../../pm/firebase';

interface Props {
  membership: TeamMembership;
  disabled?: boolean;
}

const ManageMemberMenu: React.FC<Props> = ({ membership, disabled }) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLSpanElement | null>(null);

  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (!wrapRef.current) return;
      if (!wrapRef.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, [open]);

  async function changeRole(role: TeamRole) {
    setOpen(false);
    await updateMemberRole(membership.id, role);
  }

  async function remove() {
    setOpen(false);
    if (!window.confirm('Remove this member from the team?')) return;
    await removeTeamMember(membership.id);
  }

  if (disabled) {
    return <span className="pm-link-button pm-link-disabled">Manage</span>;
  }

  return (
    <span className="pm-manage-wrap" ref={wrapRef}>
      <button className="pm-link-button" onClick={() => setOpen((v) => !v)}>Manage</button>
      {open ? (
        <div className="pm-manage-menu">
          <div className="pm-manage-section-title">Change role</div>
          {TEAM_ROLE_ORDER.map((r) => (
            <button
              key={r}
              className={r === membership.role ? 'active' : ''}
              onClick={() => changeRole(r)}
            >
              {TEAM_ROLE_LABELS[r]}
            </button>
          ))}
          <div className="pm-manage-divider" />
          <button className="pm-manage-danger" onClick={remove}>Remove from team</button>
        </div>
      ) : null}
    </span>
  );
};

export default ManageMemberMenu;
